import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getCargoTags: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_TAGS].GET_CARGO_TAGS,
	},
	getCargoTag: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_TAGS].GET_CARGO_TAG,
	},
	createCargoTag: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_TAGS].CREATE_CARGO_TAG,
	},
	putCargoTag: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_TAGS].PUT_CARGO_TAG,
	},
	patchCargoTag: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_TAGS].PATCH_CARGO_TAG,
	},
	deleteCargoTag: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CARGO_TAGS].DELETE_CARGO_TAG,
	},
}
